module.exports = "/dist/f6b6bf2431003f8142e800f9df157989.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-300italic.woff2
// module id = 119
// module chunks = 0